import { useTranslation } from "react-i18next";
import { Flex } from "antd";
import {
  AppButton,
  AppForm,
  AppModal,
  AppText,
  SettingsFormSubmitButton,
  SettingsSectionTitle,
} from "@/shared/Components";
import { FormInputPassword } from "@/shared/Components/Form/FormInputs/FormInputPassword";
import { AlertYellowIcon } from "@/shared/icons/AlertYellowIcon";
import { useChangeOldPasswordForm } from "../model";
import styles from "./styles.module.scss";

export const ChangeOldPasswordForm = () => {
  const { t } = useTranslation();
  const { formApi, onClickSubmit, isConfirmModalOpen, handleCancel, handleOk, isLoading } =
    useChangeOldPasswordForm();

  return (
    <Flex className={styles.root} vertical gap={12}>
      <SettingsSectionTitle title={t("settingsPage.general.changePassword")} />
      <p className={styles["password-note"]}>{t("validation.passwordContain")}</p>
      <AppForm formApi={formApi} className={styles.form}>
        <FormInputPassword
          className={styles.input}
          placeholder={t("settingsPage.general.currentPassword")}
          name="oldPassword"
        />
        <FormInputPassword
          className={styles.input}
          placeholder={t("settingsPage.general.newPassword")}
          name="newPassword"
        />
        <FormInputPassword
          className={styles.input}
          placeholder={t("settingsPage.general.repeatNewPassword")}
          name="confirmPassword"
        />
      </AppForm>
      <SettingsFormSubmitButton onClick={onClickSubmit} />
      <AppModal
        centered
        maskClosable={false}
        closable={false}
        open={isConfirmModalOpen}
        footer={null}
        onCancel={handleCancel}
        onOk={handleOk}
        width={360}
      >
        <Flex vertical gap={12} align="center" style={{ padding: "0 49px" }}>
          <AlertYellowIcon width={25} height={25} />
          <AppText size="md" weight="medium" style={{ textAlign: "center" }}>
            {t("settingsPage.general.confirmChanges")}
          </AppText>
          <Flex justify="center" gap={12}>
            <AppButton onClick={handleCancel}>{t("common.cancel")}</AppButton>
            <AppButton type="primary" onClick={handleOk} loading={isLoading}>
              {t("common.change")}
            </AppButton>
          </Flex>
        </Flex>
      </AppModal>
    </Flex>
  );
};
